import { render, staticRenderFns } from "./AnswersFaq.vue?vue&type=template&id=285c6dd6"
import script from "./AnswersFaq.vue?vue&type=script&lang=js"
export * from "./AnswersFaq.vue?vue&type=script&lang=js"
import style0 from "./AnswersFaq.vue?vue&type=style&index=0&id=285c6dd6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285c6dd6')) {
      api.createRecord('285c6dd6', component.options)
    } else {
      api.reload('285c6dd6', component.options)
    }
    module.hot.accept("./AnswersFaq.vue?vue&type=template&id=285c6dd6", function () {
      api.rerender('285c6dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/faq/componetesFaq/AnswersFaq.vue"
export default component.exports